import O1HD from "../../../../engines/gameEngine";
import data_control from "../../../../engines/libs/data_control";
import utilsModel from "../../../../engines/libs/utilsModel";
import WeChatFrameByAuction from "./WeChaFrameByAuciton";

const {ccclass, property} = cc._decorator;

@ccclass
export default class WeChatResultNodeAuction extends cc.Component {

    @property({type:WeChatFrameByAuction,displayName:"聊天界面"})
    chatFrame:WeChatFrameByAuction = null;

    @property({type:cc.Label,displayName:"钱的文本"})
    lb_Money:cc.Label = null;

    onEnable(){
        this.lb_Money.string = data_control.getNumberFormat(this.chatFrame.price);
    }
    
    onBtnSell(){
        this.closeThis();
        this.chatFrame.onSell();
    }

    onBtnReStart(){
        utilsModel.loadAndShowVideoAdTrans(()=>{
            this.chatFrame.startChat();
            this.closeThis();
        },()=>{},null,"看视频重新拍卖");
    }

    closeThis(){
        this.node.active = false;
    }

}
